import { privatePostApi, privateGetApi, privatePutApi } from "../../utils/apiHelper";

// PRD item 3 (FR-3.10), task 3.8. Rights-request board (Compliance page).

export const createRightsRequest = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/rights-requests", payload)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const listRightsRequests = (payload) => () => {
  return new Promise((resolve, reject) => {
    privateGetApi("/rights-requests", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result.records || []);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const updateRightsRequest = (id, payload) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi(`/rights-requests/${id}`, payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const fulfilRightsRequest = (id) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi(`/rights-requests/${id}/fulfil`, {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};
